/************************
ローダーオブジェクト
*************************/
(function($){
	var kls = function(o){
		return new _kls.prototype.init(o);
	},
	_kls = function(){}
	_kls.prototype={
		element: null
		,opt: {

		},
		init:function(o){
			var _this = this;
			var html = '<div id="myLoaderLayer" style="display: none;">&nbsp;</div><div id="myLoader" style="display: none;">&nbsp;</div>';
			this.opt = $.extend(true, {}, this.opt);
			$.extend(this.opt, o);

			this.element = $($.parseHTML(html));
			$("body").append(this.element);
			$(window).on("scroll", function(e) { _this.scrollEvent(e); });

			return this;
		},
		show: function(){
			// 2026-08 カートローダー修正: CSS fixed化によりスクロール位置へ追従させる必要はない。
			this.element.fadeIn(300, function(){

			});
		},
		hide: function(){
			this.element.fadeOut(300, function(){

			});
		},
		scrollEvent: function(e){
			// 2026-08 カートローダー修正: 旧実装はabsolute要素をscrollTopへ移動していたが、
			// Step式カートではページ高さが変わるため表示位置がずれる。互換のためメソッドだけ残す。
		}

	}
	_kls.prototype.init.prototype = _kls.prototype;
	$(function(){
		Kanaco.Loader = new kls();
	});
})(jQuery);
